(function () {
  'use strict';

  function initSlider(el) {
    if (el.dataset.nuniSlider) return;
    el.dataset.nuniSlider = '1';

    var imgs    = Array.from(el.querySelectorAll('.nuni-cslider__img'));
    var dots    = Array.from(el.querySelectorAll('.nuni-cslider__dot'));
    var link    = el.querySelector('.nuni-cslider__link');
    var prevBtn = el.querySelector('.nuni-cslider__prev');
    var nextBtn = el.querySelector('.nuni-cslider__next');
    var total   = imgs.length;
    var idx     = 0;

    function goTo(n) {
      imgs[idx].classList.remove('is-active');
      if (dots[idx]) dots[idx].classList.remove('is-active');
      idx = ((n % total) + total) % total;
      imgs[idx].classList.add('is-active');
      if (dots[idx]) dots[idx].classList.add('is-active');
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); goTo(idx - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); goTo(idx + 1);
      });
    }

    /* Touch / swipe */
    var startX = 0, startY = 0, swipeMoved = false, swipeAxis = null;

    el.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      swipeMoved = false;
      swipeAxis  = null;
    }, { passive: true });

    el.addEventListener('touchmove', function (e) {
      var dx = startX - e.touches[0].clientX;
      var dy = startY - e.touches[0].clientY;
      if (!swipeAxis) {
        swipeAxis = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
      }
      if (swipeAxis === 'x' && Math.abs(dx) > 8) swipeMoved = true;
    }, { passive: true });

    el.addEventListener('touchend', function (e) {
      if (!swipeMoved || swipeAxis !== 'x') return;
      var dx = startX - e.changedTouches[0].clientX;
      if (Math.abs(dx) > 35) goTo(dx > 0 ? idx + 1 : idx - 1);
    });

    /* Block navigation link only when a swipe actually happened */
    if (link) {
      link.addEventListener('click', function (e) {
        if (swipeMoved) { e.preventDefault(); swipeMoved = false; }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.nuni-cslider').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init after Shopify section or AJAX updates */
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('page:load',           initAll); /* instant.page */
  document.addEventListener('page:render',         initAll);
})();
